<app-modal [header]="'Dar tratamento'"
           [isShow]="displayModal"
           [style]="'w-full max-w-lg'"
           (cancel)="displayModal = false; this.onCancelModal.emit();">

  <div>
    <div class="text-xs mb-10 space-y-2">
      <p>Use os campos abaixo para decidir se o evento é adequado para estar completamente exposto ao público.</p>
    </div>

    <form method="POST" class="space-y-4" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="space-y-8">

        <div>
          <app-select-input [formGroup]="form" id="decision" [options]="decisions" [formError]="decisionError"
                            placeholder="Decisão" label="Decisão"></app-select-input>
        </div>

        <div>
          <app-text-area-input [formGroup]="form" id="motive" [rows]="4"
                               placeholder="Descrição" label="Descrição" [formError]="motiveError"
                               [value]="form.value?.motive" [maxLength]="250"
                               [resizeable]="false"></app-text-area-input>
        </div>
      </div>

      <hr>

      <!-- submit button -->
      <div class="flex justify-end">
        <app-ae-button variant="primary" label="Dar tratamento" [loading]="isLoading"
                  (buttonClick)="onSubmit()" size="sm" styleClass="justify-end"></app-ae-button>
      </div>
    </form>
  </div>

</app-modal>
